'use client';
import Link from'next/link';
 import Image from'next/image';
import { ChatBubbleIcon } from '../components/ui/chat-bubble-icon';
import { buttonClassName } from '../components/button';

type FooterProps = {
  showContactButton?: boolean
}

export default function Footer({ showContactButton = true }: FooterProps) {
  return (
    // Horizontal padding mirrors the header's own (max-lg:px-5, px-[16px], sm:px-[30px],
    // md:px-[40px], no lg override) exactly, breakpoint for breakpoint — this used to be its own
    // scale (20/40/49/98px) that matched the header at none of them, so the footer's logo sat at a
    // different inset than the header's on every viewport, most visibly 98px vs 40px at lg.
    <footer className="w-full max-lg:px-5 px-[16px] sm:px-[30px] md:px-[40px] max-lg:py-9 max-lg:mt-5 max-[380px]:py-7 max-[380px]:mt-4 lg:py-[47px] lg:sm:py-[70px] lg:md:py-[94px] lg:mt-[32px] lg:sm:mt-[48px] lg:md:mt-[64px]">
      {/* No max-w/mx-auto here (there used to be one, capped at 1242px): centering a capped-width
          row pushes the logo inward past the padding on any window wider than ~1322px, which is
          exactly how the header does NOT behave — it's a plain full-width padded row with nothing
          capping or centering it. Matching that (no cap) is what keeps the footer's logo pinned to
          the same inset as the header's at every width instead of drifting toward the middle. */}
      <div className="w-full flex flex-col items-start gap-3 sm:flex-row sm:justify-between sm:items-center sm:gap-[24px] max-[380px]:gap-3">
        <div className="flex flex-col items-start gap-3 sm:flex-row sm:items-center">
          <Link href="/" className="inline-flex items-center">
            <Image
              src="/images/proply-logo.svg"
              alt="Proply.io logo"
              width={136}
              height={38}
              className="inline-block h-[38px] w-auto shrink-0 max-lg:h-[30px] max-[380px]:h-[24px]"
            />
          </Link>

          <p className="text-[18px] font-grunell font-[400] leading-[24px] text-blue-bell-400 sm:hidden max-[380px]:text-[14px] max-[380px]:leading-[18px]">
            Titan28 Labs
          </p>

          <span className="hidden items-center gap-[12px] sm:flex max-lg:gap-2">
            <span className="ds-text-base-normal text-blue-bell-400" aria-hidden="true">
              |
            </span>
            <span className="text-[28px] font-grunell font-[400] leading-[36px] text-blue-bell-400 max-lg:text-[18px] max-lg:leading-[24px]">
              Titan28 Labs
            </span>
          </span>
        </div>

        {showContactButton ? (
          <Link href="/contact-us" className={buttonClassName('inline')}>
            <ChatBubbleIcon className="h-[18px] w-[18px]" />
            Contact Support
          </Link>
        ) : null}
      </div>
    </footer>
  )
}